import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import Button from "./Button";
import { translations, type Lang } from "../content";

export default function CookieConsent({ lang }: { lang: Lang }) {
  const t = translations[lang].cookies;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie-consent")) setOpen(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie-consent", "true");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          dir={lang === "he" ? "rtl" : "ltr"}
          className="fixed bottom-6 z-50 max-w-md panel p-6 text-foreground ltr:left-6 rtl:right-6"
        >
          <div className="flex items-center gap-2 mb-3">
            <Cookie className="w-5 h-5 text-primary" />
            <h3 className="font-bold text-primary">{t.title}</h3>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed mb-4">{t.message}</p>
          <Button
            onClick={accept}
            className="pill h-auto px-6 py-3 text-sm"
          >
            {t.accept}
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
